import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';
import { CircularProgress } from 'material-ui/Progress';
import Cached from '@material-ui/icons/Cached';

import MenuItem from 'material-ui/Menu/MenuItem';
import { Field, reduxForm, Form } from 'redux-form';
import Table from 'material-ui/Table/Table';
import TableBody from 'material-ui/Table/TableBody';
import TableCell from 'material-ui/Table/TableCell';
import TableHead from 'material-ui/Table/TableHead';
import TableRow from 'material-ui/Table/TableRow';
import TablePagination from 'material-ui/Table/TablePagination';
import renderSelectField from '../../helpers/RenderSelectField';
import validationHelper from '../../helpers/ValidationHelper';
import getQuickBookFileUrl from '../../actions/getQuickBookFileUrl';
import Layout from '../Layout';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '70%',
    height: '500px',
    display: 'inline-block',
    margin: 20,
    marginTop: '12vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 250,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '2%',
    marginLeft: '9%',
    textAlign: 'left',
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '0%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addIcon: {
    position: 'absolute',
    margin: '1%'
  },
  toolTipStyle: {
    margin: '5%',
    width: '87.1%'
  }
});

const validate = (values) => {
  const errors = validationHelper.validateRequired(['selectMonth', 'selectYear', 'referenceNumber'], values);
  return errors;
};

class GenerateInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      fetchingInvoices: false,
      invoices: [],
      pageSize: 5,
      page: 0,
      months: this.range(1, 13),
      years: this.range(new Date().getFullYear() - 5, new Date().getFullYear() + 11)
    };
  }

  componentDidMount() {
    this.handleReloadInvoices();
  }

  range = (start, end) => Array.from({ length: (end - start) }, (v, k) => k + start);

  handleSave = (event) => {
    // month is zero based
    const startDate = new Date(event.selectYear, event.selectMonth - 1, 1);
    const endDate = new Date(event.selectYear, event.selectMonth, 0);
    const startDateString = startDate.toISOString().split('T')[0];
    const endDateString = endDate.toISOString().split('T')[0];
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleReloadInvoices = () => {
    this.props.actions.listInvoices(this.props.data.config, this);
  };

  render() {
    const { classes, handleSubmit } = this.props;
    const { page, pageSize } = this.state;
    const months = this.state.months.map(o => <MenuItem key={`month-${o}`} value={o}>{o}</MenuItem>);
    const years = this.state.years.map(o => <MenuItem key={`year-${o}`} value={o}>{o}</MenuItem>);
    return (
      <Layout className="App" showMenu menuTitle="Generate invoice" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727.">
        <Paper className={classes.paperStyle}>
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title" className="lightH2">
                Generate Invoices
              </Typography>
              <IconButton title="close" component={Link} to="/">
                <Close color="disabled" />
              </IconButton>
            </Toolbar>
          </AppBar>
          <div style={{ flex: 1, flexDirection: 'row', flexAlign: 'center' }}>
            {this.state.fetching && <div align="center"><CircularProgress size={75} /></div>}
            {!this.state.fetching &&
              <Form onSubmit={handleSubmit(this.handleSave)}>
                <div style={{ flex: 0.5 }} >
                  <Field name="selectMonth" component={renderSelectField} label="Invoice Month" className={classes.textField} divClassName={classes.formControl} >
                    {months}
                  </Field>
                  <Field name="selectYear" component={renderSelectField} label="Invoice Year" className={classes.textField} divClassName={classes.formControl} >
                    {years}
                  </Field>
                </div>
                <div style={{ flex: 0.2 }} >
                  <Button variant="raised" color="primary" type="submit">Submit</Button>
                </div>
              </Form>
            }
            {this.state.fetchingInvoices && <div align="center"><CircularProgress size={75} /></div>}
            {!this.state.fetchingInvoices &&
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Period</TableCell>
                    <TableCell>Quickbooks generated<IconButton onClick={this.handleReloadInvoices}><Cached /></IconButton></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.invoices.slice(page * pageSize, (page * pageSize) + pageSize).map(invoice => (
                    <TableRow key={invoice.period}>
                      <TableCell component="th" scope="row"><a href={invoice.url}>{invoice.period}</a></TableCell>
                      <TableCell>{invoice.fileExported ? 'Yes' : 'No'}</TableCell>
                    </TableRow>))}
                </TableBody>
              </Table>
            }
          </div>
          <TablePagination
            component="div"
            count={this.state.invoices.length}
            rowsPerPage={this.state.pageSize}
            page={this.state.page}
            rowsPerPageOptions={5}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
          />
        </Paper>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    person: state.person.person,
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    listInvoices: (config, self) => {
      self.setState({ fetchingInvoices: true });
      dispatch(getQuickBookFileUrl(config)).then((result) => {
        self.setState({ fetchingInvoices: false });
        // console.log(result);
        const { data } = result.value;
        if (data) {
          self.setState({ invoices: data });
        }
      }).catch((error) => {
        self.setState({ fetchingInvoices: false });
        dispatch({ type: 'SHOW_ERROR_DIALOG', payload: error.message });
      });
    }
  }
});

const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateInvoice);


export default withStyles(styles, { withTheme: true })(reduxForm({ form: 'GenerateInvoiceForm', validate })(Connected));


// WEBPACK FOOTER //
// ./src/components/Reporting/GenerateInvoice.js